{
  "title": "Бюджет",
  "lead": "Сколько проекту можно тратить в месяц, без НДС. Уведомления при 50, 80 и 100\u00a0%; ничего не выключается и не удаляется само.",
  "used": "Израсходовано",
  "forecastUse": "Прогноз на месяц",
  "ofBudget": "от бюджета {{amount}} на этот месяц",
  "raisedThisMonth": "из них разовое увеличение {{amount}}",
  "usedShort": "Израсходовано {{percent}}\u00a0%",
  "forecastShort": "Прогноз — {{percent}}\u00a0% бюджета",
  "summary": "{{amount}} · прогноз {{percent}}\u00a0%",
  "set": "Задать бюджет",
  "change": "Изменить бюджет",
  "remove": "Убрать бюджет",
  "requestRaise": "Запросить увеличение",
  "decide": "Рассмотреть",
  "decided": "Запрос уже рассмотрен.",
  "monthly": "В месяц",
  "margin": "Запас на изменения",
  "marginShort": "запас {{margin}}\u00a0%",
  "marginValue": "{{margin}}\u00a0% — до {{limit}}",
  "marginDefault": "Как в организации",
  "marginOwn": "Свой для этого проекта",
  "marginLabel": "Запас на изменения, %",
  "marginHint": "Насколько прогноз может превысить бюджет из-за изменений уже работающих услуг — для срочных небольших правок. Пусто — как в организации ({{margin}}\u00a0%).",
  "marginInvalid": "Целое число от 0 до 100.",
  "ruleNew": "Новые платные услуги — серверы, диски, IP-адреса, плавающие IP, снимки, балансировщики — нельзя заказать, когда прогноз месяца достигает бюджета.",
  "ruleChange": "Изменения уже работающих услуг — тип сервера, резервные копии, размер диска, IPv4 для сервера — разрешены, пока прогноз не выше бюджета плюс запас на изменения ({{margin}}\u00a0%).",
  "ruleNothing": "Удалять, уменьшать и выключать можно всегда. Администраторов правила не останавливают — их только предупреждают.",
  "exceededBadge": "Бюджет достигнут: новые услуги не заказываются",
  "thresholds": "Пороги уведомлений, %",
  "thresholdsHint": "Через запятую, например 50, 80, 100: уведомление приходит раз в месяц по факту и по прогнозу.",
  "thresholdsInvalid": "От одного до пяти разных чисел от 1 до 200.",
  "none": "Бюджет не задан: расходы проекта ничем не ограничены.",
  "noneShort": "Без бюджета",
  "history": "История бюджета",
  "historyFrom": "С {{month}}",
  "alert": {
    "actual": "Израсходовано {{threshold}}\u00a0% бюджета",
    "forecast": "Прогноз достиг {{threshold}}\u00a0% бюджета"
  },
  "raises": "Запросы на увеличение",
  "raiseAmount": "Увеличение",
  "kinds": {
    "once": "Только на этот месяц",
    "permanent": "Постоянно"
  },
  "reason": "Причина",
  "requestedBy": "Кто и когда",
  "status": "Решение",
  "statuses": {
    "pending": "Ждёт решения",
    "approved": "Одобрено",
    "rejected": "Отклонено"
  },
  "saved": "Бюджет сохранён",
  "removed": "Бюджет убран",
  "dialogLead": "Сумма на календарный месяц без НДС, в валюте прайс-листа. Действует с этого месяца; прошлые месяцы сохраняют свой бюджет. Изменение подтверждается вторым фактором.",
  "amountLabel": "Бюджет в месяц, {{currency}}",
  "amountHint": "Например 250 или 99,90.",
  "amountInvalid": "Введите сумму больше нуля, например 250 или 99,90.",
  "raiseLead": "Администраторы получат запрос и решат: одобрить или отклонить.",
  "raiseBy": "Увеличить на, {{currency}}",
  "raiseKind": "На какой срок",
  "send": "Отправить запрос",
  "requested": "Запрос отправлен администраторам",
  "decideTitle": "Запрос на увеличение бюджета: {{project}}",
  "decideLead": "{{name}} просит {{amount}} ({{kind}}). Решение подтверждается вторым фактором.",
  "note": "Комментарий (необязательно)",
  "approve": "Одобрить",
  "reject": "Отклонить",
  "approved": "Запрос одобрен",
  "rejected": "Запрос отклонён",
  "pending": "Запросы на увеличение бюджета",
  "pendingLead": "Владельцы проектов просят больше. Одобренное разовое увеличение действует до конца месяца, постоянное меняет бюджет с этого месяца.",
  "defaultTitle": "Запас на изменения по умолчанию",
  "defaultLead": "Насколько прогноз может превысить бюджет из-за изменений уже работающих услуг — для проектов, где запас не задан свой. Новые услуги запас не открывает.",
  "defaultMargin": "Запас, %",
  "defaultSaved": "Запас по умолчанию сохранён",
  "exceededNew": "Бюджет проекта {{budget}} достигнут: новые платные услуги не заказываются (прогноз месяца после заказа — {{forecast}}).",
  "exceededChange": "Прогноз месяца после изменения — {{forecast}}, это на {{over}} больше бюджета с запасом на изменения {{margin}}\u00a0% ({{limit}}).",
  "changeAdds": "Добавит к этому месяцу около {{amount}} ({{monthly}} в полный месяц), без НДС.",
  "willBeRefusedNew": "Бюджет проекта {{budget}} будет достигнут или уже достигнут: новая услуга будет отклонена (превышение на {{over}}).",
  "willBeRefusedChange": "Изменение выведет прогноз за бюджет с запасом на изменения {{margin}}\u00a0% ({{limit}}) на {{over}} и будет отклонено.",
  "overAsAdminNew": "Бюджет проекта {{budget}} будет превышен на {{over}}. Вы администратор: заказ не будет остановлен.",
  "overAsAdminChange": "Изменение выйдет за бюджет с запасом ({{limit}}) на {{over}}. Вы администратор: оно не будет остановлено."
}
